module.exports = __webpack_public_path__ + "img/组 129.5d0cbb0c.png";